import { resolveComponent as _resolveComponent, createVNode as _createVNode, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, vShow as _vShow, normalizeClass as _normalizeClass, withDirectives as _withDirectives, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "col row" }
const _hoisted_2 = { class: "col-xs-12 title q-mb-md" }
const _hoisted_3 = { class: "col-xs-12 description" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_ServiceTypeBadge = _resolveComponent("ServiceTypeBadge")!
  const _component_s_icon = _resolveComponent("s-icon")!
  const _component_s_btn = _resolveComponent("s-btn")!

  return _withDirectives((_openBlock(), _createElementBlock("div", {
    class: _normalizeClass(["service__item-card row items-start", { 'service__item-card--mobile': _ctx.isMobile }]),
    onClick: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_ctx.goToService && _ctx.goToService(...args)))
  }, [
    _createVNode(_component_ServiceTypeBadge, {
      service: _ctx.service,
      "content-class": "q-mt-md q-mr-md"
    }, null, 8, ["service"]),
    _createVNode(_component_s_icon, {
      name: _ctx.getIconName(),
      size: 80,
      class: "s-pl-lg s-pr-md col-auto",
      onClick: _ctx.goToService
    }, null, 8, ["name", "onClick"]),
    _createElementVNode("div", _hoisted_1, [
      _createElementVNode("div", _hoisted_2, _toDisplayString(_ctx.getServiceName), 1),
      _createElementVNode("div", _hoisted_3, _toDisplayString(_ctx.getDescription), 1)
    ]),
    _createVNode(_component_s_btn, {
      class: "service__item-btn s-btn--icon__service",
      type: "icon",
      icon: "app:arrow-normal-right"
    })
  ], 2)), [
    [_vShow, !_ctx.isLoading]
  ])
}